// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content074_wrapper__Q88Go","files":"Content074_files__FcESP","file":"Content074_file__0GYfl","title":"Content074_title__syuCu"};